export default __webpack_public_path__ + "static/media/ic_coingecko_hover_16.ef20d202.svg";